<template>
  <v-btn
    v-if="me && me.id === '0' && id !== '0'"
    @click="impersonate"
    class="primary accent-4 white--text mr-2 my-1"
    small
  >
    <v-icon small left>perm_identity</v-icon
    >{{ $t("profile.assignment.impersonate") }}
  </v-btn>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["id"],
  computed: {
    ...mapState(["me"]),
  },
  methods: {
    impersonate() {
      this.$store
        .dispatch("login", { username: this.id, password: "" })
        .then(() => this.$router.push("/"));
    },
  },
};
</script>
